import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-medical-docs-download-block-component',
    templateUrl: './medical-docs-download-block.component.html',
    styleUrls: [],
})
export class MedicalDocsDownloadBlockComponent {
    @Input() downloadDescription =
        'documentselection.documentlist.buttons.showlist.details';
    @Output() download: EventEmitter<boolean> = new EventEmitter();

    downloadFile(): void {
        this.download.emit(true);
    }
}
